<template>
  <div class="daily-progress-chart">
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<script>
import {
  Chart,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Filler,
  Tooltip,
} from "chart.js";
// import { toRaw } from "vue";

Chart.register(
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Filler,
  Tooltip
);

export default {
  name: "DailyProgressChart",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    if (this.data.length > 0) {
      this.renderChart();
    }
  },
  watch: {
    data: {
      handler(newData) {
        if (newData && newData.length > 0) {
          if (this.chart) {
            this.updateChart();
          } else {
            this.renderChart();
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    renderChart() {
      if (!this.$refs.chartCanvas) return;
      
      const ctx = this.$refs.chartCanvas.getContext("2d");

      const chartData = JSON.parse(JSON.stringify(this.data || []));
      
      const labels = chartData.map((d) => d.label);
      const dataPoints = chartData.map((d) => d.value);

      this.chart = new Chart(ctx, {
        type: "line",
        data: {
          labels: labels,
          datasets: [
            {
              label: "Daily Progress",
              data: dataPoints,
              borderColor: "#222222",
              backgroundColor: "rgba(34, 34, 34, 0.1)",
              borderWidth: 2,
              fill: true,
              tension: 0.4,
              pointRadius: 4,
              pointBackgroundColor: "#222222",
              pointBorderColor: "#fff",
              pointBorderWidth: 2,
              pointHoverRadius: 6,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              backgroundColor: "#222222",
              titleColor: "#fff",
              bodyColor: "#fff",
              padding: 12,
              cornerRadius: 8,
              displayColors: false,
              callbacks: {
                label: function (context) {
                  return `Progress: ${context.parsed.y}%`;
                },
              },
            },
          },
          scales: {
            y: {
              beginAtZero: true,
              max: 100,
              ticks: {
                stepSize: 20,
                color: "#98A2B3",
                font: {
                  size: 10,
                },
              },
              grid: {
                color: "#EAECF0",
                drawBorder: false,
              },
            },
            x: {
              ticks: {
                color: "#98A2B3",
                font: {
                  size: 10,
                },
              },
              grid: {
                display: false,
                drawBorder: false,
              },
            },
          },
        },
      });
    },
    updateChart() {
      if (this.chart && this.data && this.data.length) {
        const chartData = JSON.parse(JSON.stringify(this.data));
        
        this.chart.data.labels = chartData.map((d) => d.label);
        this.chart.data.datasets[0].data = chartData.map((d) => d.value);
        this.chart.update();
      }
    },
  },
  beforeUnmount() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  },
};
</script>

<style scoped>
.daily-progress-chart {
  width: 100%;
  height: 220px;
}
</style>
